export default "__VITE_ASSET__DBLspkwy__"